export const PWA_UPDATE_READY_EVENT = 'dohockey:pwa-update-ready';

const dispatchUpdateReady = (registration: ServiceWorkerRegistration) => {
  window.dispatchEvent(new CustomEvent(PWA_UPDATE_READY_EVENT, { detail: registration }));
};

export const registerPortalPwa = async (): Promise<ServiceWorkerRegistration | null> => {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return null;

  try {
    const registration = await navigator.serviceWorker.register('/service-worker.js', {
      scope: '/',
      updateViaCache: 'none',
    });

    if (registration.waiting && navigator.serviceWorker.controller) {
      dispatchUpdateReady(registration);
    }

    registration.addEventListener('updatefound', () => {
      const installing = registration.installing;
      if (!installing) return;
      installing.addEventListener('statechange', () => {
        if (installing.state === 'installed' && navigator.serviceWorker.controller) {
          dispatchUpdateReady(registration);
        }
      });
    });

    const checkForUpdate = () => {
      if (document.visibilityState === 'visible') void registration.update();
    };
    window.setInterval(checkForUpdate, 60 * 60 * 1000);
    document.addEventListener('visibilitychange', checkForUpdate);
    return registration;
  } catch (error) {
    console.warn('Portal PWA registration failed', error);
    return null;
  }
};
